import { isMobileDeviceNow, isPhoneDeviceNow } from './isMobileDevice';

/**
 * ¿Hay que montar la app mobile (`PwaApp`: login + una sola pantalla) en vez de la plataforma completa?
 * Sí cuando está instalada como PWA (ventana standalone, sin barra del navegador) **en un celular**.
 * Instalada en una tablet o en Windows/Mac (desktop) NO: ahí la PWA es la plataforma completa, igual que
 * la web — ver `src/index.tsx`. (Coincide con la landing "Instalá la app": solo los celulares la ven.)
 *
 * `?pwa=1` fuerza el modo mobile para probarlo desde cualquier navegador sin instalar nada (se
 * evalúa una vez al cargar; no se persiste).
 */
export function isPwaMode(): boolean {
  if (typeof window === 'undefined') return false;

  // El popup del login con Google vuelve a /login y le avisa a la ventana que lo abrió: tiene
  // que montar la app completa (que maneja ese callback), aunque se abra dentro de la PWA.
  if (window.opener) return false;

  if (new URLSearchParams(window.location.search).get('pwa') === '1') return true;

  return isStandaloneDisplay() && isPhoneDeviceNow();
}

/** ¿Se abrió como app instalada (ventana standalone, sin la barra del navegador)? */
export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false;
  const standaloneMedia = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
  // iOS Safari no soporta el media query: expone `navigator.standalone`.
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return standaloneMedia || iosStandalone;
}

/**
 * ¿Es una TABLET con la app instalada? Corre la plataforma web completa (con las videollamadas), igual que en el navegador, pero con el
 * bloqueo por notificaciones que tiene el celular (`InstalledTabletPushGate`).
 */
export function isInstalledTablet(): boolean {
  return isStandaloneDisplay() && isMobileDeviceNow() && !isPhoneDeviceNow();
}
